<template>
  <div v-if="loaded" :class="`switcher-wrap switcher-${theme} switcher-${direction ? 'close' : 'open'} switcher-${animated ? '' : 'loaded'}`">
    <div :class="`switcher-animation switcher-animation-${arrowAnimation ? 'active' : ''}`">
      <div @click="changeTheme" class="switcher">
        <svg class="switcher--arrow" xmlns="http://www.w3.org/2000/svg" width="31" height="33" viewBox="0 0 31 33">
          <path fill="#FFFFFF" d="M0.5,2.5 C0.5,1.3954305 1.3954305,0.5 2.5,0.5 C3.6045695,0.5 4.5,1.3954305 4.5,2.5 L4.5,30.7842712 C4.5,31.8888407 3.6045695,32.7842712 2.5,32.7842712 C1.3954305,32.7842712 0.5,31.8888407 0.5,30.7842712 L0.5,2.5 Z M13.5,2.5 C13.5,1.3954305 14.3954305,0.5 15.5,0.5 C16.6045695,0.5 17.5,1.3954305 17.5,2.5 L17.5,30.7842712 C17.5,31.8888407 16.6045695,32.7842712 15.5,32.7842712 C14.3954305,32.7842712 13.5,31.8888407 13.5,30.7842712 L13.5,2.5 Z M26.5,2.5 C26.5,1.3954305 27.3954305,0.5 28.5,0.5 C29.6045695,0.5 30.5,1.3954305 30.5,2.5 L30.5,30.7842712 C30.5,31.8888407 29.6045695,32.7842712 28.5,32.7842712 C27.3954305,32.7842712 26.5,31.8888407 26.5,30.7842712 L26.5,2.5 Z"/>
        </svg>
        <svg class="switcher--arrow switcher--arrow-moby" width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g transform="translate(-1327.000000, -317.000000)" fill="#FFFFFF" fill-rule="nonzero" stroke="#FFFFFF" stroke-width="2">
            <g id="Group-2" transform="translate(1290.000000, 280.000000)">
                <polygon id="Path" points="63.2624764 50.3123042 51.6421698 38.8826421 52.5395342 38 66 51.2396314 65.1026356 52.1222735 65.0976008 52.1173212 51.7907374 65.2058702 50.893373 64.3232281 63.8689315 51.5605486 38 51.5605486 38 50.3123042 63.2624764 50.3123042"></polygon>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';

export default {
  name: 'switcher',
  computed: mapGetters({
    loaded: 'loaded',
    theme: 'theme',
  }),
  data() {
    return {
      animated: false,
      direction: false,
      arrowAnimation: true,
    };
  },
  watch: {
    loaded() {
      if (this.loaded) {
        setTimeout(() => {
          this.animated = true;
        }, 3000);
      }
    },
  },
  mounted() {
    setInterval(() => {
      this.arrowAnimation = !this.arrowAnimation;
    }, 5000);
  },
  methods: {
    changeTheme() {
      this.direction = !this.direction;
      const isWhite = this.theme === 'white';
      const th = isWhite ? 'dark' : 'white';
      this.$store.commit(types.THEME_SWITCHED, true);
      this.$store.dispatch('changeTheme', th);
      this.checkUrl(isWhite);
    },
    checkUrl(isWhite) {
      const darkPath = 'dark';
      if (!isWhite && location.pathname.indexOf(darkPath) > -1) {
        this.$router.push(location.pathname.replace(`/${darkPath}`, ''));
      } else if (isWhite && location.pathname.indexOf(darkPath) < 0) {
        this.$router.push(`/${darkPath}${location.pathname}`);
      }
    },
  },
};
</script>

<style scoped>
  @keyframes loaded{
    from, 50%{
      transform: scale(0.4);
      opacity: 0;
    }
    80%,
    to{
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes switchers {
    from{
      transform: scale(1);
    }
    50%{
      transform: scale(1.1);
    }
    to{
      transform: scale(1);
    }
  }

  @keyframes arrow {
    0%{
      transform: translate3d(0,0,0);
      opacity: 1;
    },
    48%{
      transform: translate3d(70px,0,0);
      opacity: 1;
    }
    49%{
      transform: translate3d(70px,0,0);
      opacity: 1;
    }
    50%{
      opacity: 0;
    }
    50%{
      transform: translate3d(-70px,0,0);
    }
    51%{
      transform: translate3d(-70px,0,0);
      opacity: 1;
    }
    100%{
      transform: translate3d(0,0,0);
      opacity: 1;
    }
  }

  .switcher{
    transition: transform 500ms cubic-bezier(0.675, -0.040, 0.295, 1.500);
    background: linear-gradient(217.97deg, #FF6262 0%, #FF9933 57.9%);
    box-shadow: 8px 10px 26px 0px rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    overflow: hidden;
    left: 0;
    top: 0;

    &-loaded{
      .switcher{
        animation: loaded 3s cubic-bezier(0.675, -0.040, 0.295, 1.500);
      }
    }

    &,
    &-animation{
      transform-origin: center center;
      position: absolute;
      cursor: pointer;
      height: 100px;
      width: 100px;      
      z-index: 990;

      @media (max-width: $mediaMini) {
        height: 60px;
        width: 60px;
      }
    }

    &-animation{
      right: -35px;
      top: 33vh;  
      &-active{
        .switcher-white & {
          animation: switchers 1100ms cubic-bezier(0.675, -0.040, 0.295, 1.500);
        }
      }
    }

    &-wrap{
      transition: all $mainAnimationTime $mainAnimationTransition;
      max-width: $whitePageMaxWide;
      width: $whitePageWide;
      position: fixed;
      height: 0px;
      z-index: 90;
      left: 0;
      top: 0;

      @media(max-width: $whitePageMaxWide){
        max-width: 90vw;
      }
    }

    &-wrap:hover{
      .switcher{
        & {
          transform: scale(1.1);
          animation: none;
        }
        &--arrow-moby{
          /*transform: rotateZ(-180deg);*/
          animation: none;
        }
      }
    }

    &-close{
      .switcher{
        & {
          transform: none;
        }
        &--arrow-moby{
          transform: rotateZ(-180deg);
        }
      }
    }

    &-open,
    &-close:hover{
      &,
      .switcher--arrow{
        /*transform: none;*/
      }
    }

    &--arrow{
      transition: transform 500ms cubic-bezier(0.675, -0.040, 0.295, 1.500);
      transform-origin: center center;
      display: inline-block;
      margin: 35px 36px;
      width: 30px;

      &-animate{
        .switcher-white &{
          animation: arrow 800ms cubic-bezier(0.530, -0.600, 0.000, 1.650);
          animation-delay: 300ms;
        }
      }
      @media (max-width: $mediaMini) {
        margin: 15px 20px;
        display: none;
        width: 20px;
      }

      &-moby{
        animation: none;
        display: none;
        @media (max-width: $mediaMini) {
          display: inline-block;
        }
      }
    }

    &-dark{
      max-width: $whitePanel;
      @media (max-width: $mediaMini) {
        max-width: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SwitcherButton.vue